import APIHelper from "helpers/APIHelper";
import { DocuSignEnvelopeStatusEnum, ESignatureRedirectSourceEnum } from "helpers/enums";
import { IEsignatureSettings, IESignatureResult, IESignatureEnvelopeParams, IESignatureDocument, IESignatureDocumentStatus } from "models/IESignature";

export default class ESignatureAPI {

    public static async GetQuoteDocument(mfgCustomerID: string, mfgSiteID: string, oKey: number) : Promise<IESignatureDocument> {
        const url: string = 'api/ESignature/QuoteDocument';

        const params = {
            mfgCustomerID: mfgCustomerID,
            mfgSiteID: mfgSiteID,
            oKey: oKey
        }

        const response = await APIHelper.GetAsync<IESignatureDocument>(url, params);
        return response.Result;
    }

    public static async GetAuthURIFromCustomer(mfgCustomerID: string, mfgSiteID: string, redirectURL: string, redirectSource: ESignatureRedirectSourceEnum) : Promise<IESignatureResult<string>> {
        const url: string = 'api/ESignature/AuthURI/Customer';

        const params = {
            mfgCustomerID: mfgCustomerID,
            mfgSiteID: mfgSiteID,
            redirectURL: redirectURL,
            redirectSource: redirectSource
        }

        const response = await APIHelper.GetAsync<IESignatureResult<string>>(url, params);
        return response.Result;
    }

    public static async GetAuthURIFromOKey(oKey: number, redirectURL: string, redirectSource: ESignatureRedirectSourceEnum) : Promise<IESignatureResult<string>> {
        const url: string = 'api/ESignature/AuthURI/OKey';

        const params = {
            oKey: oKey,
            redirectURL: redirectURL,
            redirectSource: redirectSource
        }

        const response = await APIHelper.GetAsync<IESignatureResult<string>>(url, params);
        return response.Result;
    }

    public static async GetEnvelopeDefaults(oKey: number) : Promise<IESignatureEnvelopeParams> {
        const url: string = 'api/ESignature/EnvelopeDefaults';

        const params = {
            oKey: oKey
        }

        const response = await APIHelper.GetAsync<IESignatureEnvelopeParams>(url, params);
        return response.Result;
    }

    public static async SendEmail(mfgCustomerID: string, mfgSiteID: string, oKey: number, envelope: IESignatureEnvelopeParams) : Promise<IESignatureResult<boolean>> {
        const url: string = 'api/ESignature/SendEmail';

        const params = {
            mfgCustomerID: mfgCustomerID,
            mfgSiteID: mfgSiteID,
            oKey: oKey
        }

        const body = envelope;
        const response = await APIHelper.PostAsync<IESignatureResult<boolean>>(url, params, body);
        return response.Result;
    }

    public static async GenerateEmbeddedURI(oKey: number, redirectURL: string, envelope: IESignatureEnvelopeParams) : Promise<IESignatureResult<string>> {
        const url: string = 'api/ESignature/EmbeddedURI';

        const params = {
            oKey: oKey,
            redirectURL: redirectURL
        }

        const body = envelope;
        const response = await APIHelper.PostAsync<IESignatureResult<string>>(url, params, body);
        return response.Result;
    }

    public static async UpdateESignatureDocumentStatus(oKey: number, status: DocuSignEnvelopeStatusEnum) : Promise<boolean> {
        const url: string = 'api/ESignature/Status';

        const params = {
            oKey: oKey,
            status: status
        }

        const response = await APIHelper.PostAsync(url, params);
        return response.IsOk();
    }

    public static async RefreshDocumentStatus(documentStatus: IESignatureDocumentStatus) : Promise<IESignatureResult<IESignatureDocumentStatus>> {
        const url: string = 'api/ESignature/RefreshStatus';

        const body = documentStatus;
        const response = await APIHelper.PostAsync<IESignatureResult<IESignatureDocumentStatus>>(url, null, body);
        return response.Result;
    }

    public static async RefreshDocumentStatuses(documentStatuses: IESignatureDocumentStatus[]) : Promise<IESignatureResult<IESignatureDocumentStatus[]>> {
        const url: string = 'api/ESignature/RefreshStatuses';

        const body = documentStatuses;
        const response = await APIHelper.PostAsync<IESignatureResult<IESignatureDocumentStatus[]>>(url, null, body);
        return response.Result;
    }

    public static async GetMaintenanceStatusList(oKeys: number[]) : Promise<IESignatureDocumentStatus[]> {
        const url: string = 'api/ESignature/StatusList';

        const body = oKeys;
        const response = await APIHelper.PostAsync<IESignatureDocumentStatus[]>(url, null, body);
        return response.Result;
    }

    public static async GenerateTokens(mfgCustomerGUID: string, accessCode: string) : Promise<IESignatureResult<boolean>> {
        const url: string = 'api/ESignature/Tokens';

        const params = {
            mfgCustomerGUID: mfgCustomerGUID,
            accessCode: accessCode
        }

        const response = await APIHelper.PostAsync<IESignatureResult<boolean>>(url, params);
        return response.Result;
    }

    public static async PingTest(mfgCustomerID: string, mfgSiteID: string) : Promise<IESignatureResult<boolean>> {
        const url: string = 'api/ESignature/PingTest';
        const params = {
            mfgCustomerID: mfgCustomerID,
            mfgSiteID: mfgSiteID
        }
        const response = await APIHelper.GetAsync<IESignatureResult<boolean>>(url, params);
        return response.Result;
    }

    public static async GetESignSettings(mfgCustomerID: string, mfgSiteID: string): Promise<IEsignatureSettings> {
        const url: string = 'api/ESignature/Settings';
        const params = {
            mfgCustomerID: mfgCustomerID,
            mfgSiteID: mfgSiteID
        }
        const response = await APIHelper.GetAsync<IEsignatureSettings>(url, params);
        return response.Result;
    }

    public static async UpdateESignSettings(mfgCustomerID: string, mfgSiteID: string, settings: IEsignatureSettings) {
        const url: string = 'api/ESignature/Settings';
        const params = {
            mfgCustomerID: mfgCustomerID,
            mfgSiteID: mfgSiteID
        }
        const body = settings;

        const response = await APIHelper.PostAsync(url, params, body);
        return response.IsOk();
    }
}